<template>
  <v-container fluid class="py-0" :style="'height:' + computedPageHeight + 'px'">

    <v-row>
      <v-col
        class="pa-0">

        <!-- on image bar -->
        <v-row class="carousel-top-element white--text">
          <v-col class="py-0 max-width-1200 mx-auto">
            <app-bar-menu
              component="Tao"
              logo="light"
              dark="dark">
            </app-bar-menu>
          </v-col>
        </v-row>

        <!-- hero -->
        <v-card flat dark>
          <v-img
            id="img-main"
            src="@/assets/img/em-tao-01.jpg"
            class="grey lighten-2"
            cover
            :min-height="breakpoint ? '' : 750"
            :max-height="computedPageHeight"
            :style="'height:' + computedPageHeight + 'px'">
            <div class="overlay">

            <!-- TODO wrap on small display -->
              <v-row
                class="fill-height max-width-1200 mx-auto"
                align="center"
                justify="center">
                <v-col cols="12" class="max-width-600 mr-auto">
                  <v-row>
                    <v-col class="text-start">
                      <span class="product-brand">{{$t("rubin.rubin")}}</span><br>
                      <span class="product-name">{{ $t('energyManagement.service.tao.title') }}</span>
                    </v-col>
                  </v-row>
                  <v-row
                    v-for="(item,index) in pros"
                    :key="index">
                    <v-col class="text-start product-pro border-bottom-dark">
                      {{ $t(item.short) }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- ic img -->
              <v-row class="carousel-bottom-controls">
                <v-col class="pa-0 img-ic-box flip-x">
                </v-col>
              </v-row>

              <!-- landing scroll menu -->
              <v-row class="menu landing-scroll">
                <v-col class="max-width-1200 px-0 mx-auto">
                  <v-btn
                    id="back" name="back" title="back"
                    text dark
                    @click="loadPage('EnergyManagement')">
                      <v-icon>
                        mdi-chevron-double-left
                      </v-icon>
                  </v-btn>
                  <v-btn
                    v-for="(item,index) in sections"
                    :key="index"
                    text dark
                    @click="scrollTOSection(item.id)">
                      {{ $t(item.title) }}
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-img>
        </v-card>

        <v-row class="mx-1">
          <v-col id="about">
            <About></About>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col id="process">
            <Process></Process>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col id="conditions">
            <Conditions></Conditions>
          </v-col>
        </v-row>
        <v-row class="mx-1">
          <v-col id="contact">
            <Obligations></Obligations>
          </v-col>
        </v-row>
        <v-row class="bg-ruby">
          <v-col id="obligations">
            <Contact></Contact>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-container>
</template>


<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import About from '@/components/EnergyManagement/Tao/About.vue'
  import Process from '@/components/EnergyManagement/Tao/Process.vue'
  import Conditions from '@/components/EnergyManagement/Tao/Conditions.vue'
  import Obligations from '@/components/EnergyManagement/Tao/Obligations.vue'
  import Contact from '@/components/Common/Contact.vue'


  export default {
    name: 'Tao',
    name: 'Career',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: ''
      },
      {
        vmid: 'keywords',
        name: 'keywords',
        content: ''
      }
    ],

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      About,
      Process,
      Conditions,
      Obligations,
      Contact,
    },

    data: () => ({
      pros: [
        { title: "", short: "tao.pros.01.short", component: "",},
        { title: "", short: "tao.pros.02.short", component: "",},
        // { title: "", short: "tao.pros.03.short", component: "",},
      ],
      sections: [
        { id: "about",          title: "common.about", },
        { id: "process",        title: "common.process", },
        { id: "conditions",     title: "common.conditions", },
        { id: "obligations",    title: "common.obligations", },
      ],
    }),

    mounted() {
    },

    computed: {
      breakpoint() {
        if (this.computedWidth < 961) {
          return true
        } else {
          return false
        }
      },
      computedCarouselHeight() {
        return this.styleProps.windowHeight;
      },
    },

    methods: {
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      }
    },

  }

</script>

<style src="../../Style.css">
</style>
